import {
  Button,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../components/PageHeader";
import ProgramsCard from "../components/ProgramsCard";
import { AuthUserContext, withAuthorization } from "../components/Session";
import { getAllProgramsByUser } from "../components/DataNet/DataNet";
import ErrorDialog from "../components/ErrorDialog";
import { Add, Cancel, Check, Delete, Edit, Opacity, Remove, Search, ViewList, ViewModule, Visibility } from "@material-ui/icons";
import ProgramDialog from "../components/ProgramForm/ProgramDialog";
import DeleteDialog from "../components/ProgramForm/DeleteDialog";
import * as ROUTES from "../constants/routes";
import { grey, purple } from "@material-ui/core/colors";
import LoadingProgramCard from "../components/ProgramsCard/LoadingProgramCard";
import { useHistory, Redirect } from "react-router-dom";
import { hasPermission } from "../functions/authorization";
import { PROGRAMS_SELECT, PROGRAMS_ADD, PROGRAMS_DELETE, PROGRAMS_UPDATE } from "../constants/roles";

const ProgramsPage = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [programs, setPrograms] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [areProgramsLoaded, setAreProgramsLoaded] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [listMode, setListMode] = useState(true);
  const [openProgramModal, setOpenProgramModal] = useState(false);
  const [editProgram, seteditProgram] = useState(false);
  const [editinId, setEditinId] = useState("");
  const [opendeleteModal, setOpendeleteModal] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    !openProgramModal && loadData();
  }, [openProgramModal]);

  useEffect(() => {
    !opendeleteModal && loadData();
  }, [opendeleteModal]);

  const loadData = () => {
    setAreProgramsLoaded(false);
    getAllProgramsByUser().then((snap) => {
      if (snap.status < 0) {
        setErrorMsg(t(`error.connection_${snap.status}`));
        setPrograms([]);
      } else {
        setPrograms(snap.data);
      }
      setAreProgramsLoaded(true);
    });
  };

  const handleCreate = () => {
    seteditProgram(false);
    setOpenProgramModal(true);
  };

  const handleEdit = (id) => {
    seteditProgram(true);
    setOpenProgramModal(true);
    setEditinId(programs.filter((p) => p?.programId == id)[0]);
  };

  const handleDelete = (id) => {
    setOpendeleteModal(true);
    setOpenProgramModal(false);
    setEditinId(programs.filter((p) => p?.programId == id)[0]);
  };

  const canDelete = (id, userPrograms) => {
    return !userPrograms.find((p) => p.id === id)?.groups?.length > 0;
  };

  return (
    <AuthUserContext.Consumer>
      {(authUser) => {
        const canAccessPrograms = hasPermission(authUser, PROGRAMS_SELECT);
        const canCreateProgram = hasPermission(authUser, PROGRAMS_ADD);
        const canUpdateProgram = hasPermission(authUser, PROGRAMS_UPDATE);
        const canDeleteProgram = hasPermission(authUser, PROGRAMS_DELETE);

        return canAccessPrograms ? (
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <PageHeader title={t("programs.title")} />
              </Grid>

              <Grid item xs={12}>
                <Paper style={{ padding: 12 }}>
                  <Grid container item md={12}>
                    <Grid item xs={8} md={4}>
                      <TextField
                        label={t("common.search")}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        onChange={(e) => setFilterName(e.target.value)}
                        placeholder={t("common.search")}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xs={4}
                      md={8}
                      container
                      direction="row"
                      style={{
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Grid item>
                        <Tooltip
                          title={
                            !canCreateProgram
                              ? t("permissions.noPermission")
                              : t("añadir programa")
                          }
                        >
                          <span>
                            <IconButton
                              aria-label="add-program"
                              color="primary"
                              disabled={!canCreateProgram}
                              onClick={handleCreate}
                            >
                              <Add style={{ fontSize: 26 }} />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Grid>

                      <Grid item>
                        <Tooltip title={t("cambiar vista")}>
                          <IconButton
                            aria-label="change-view"
                            color="primary"
                            onClick={() => setListMode(!listMode)}
                          >
                            {!listMode ? (
                              <ViewModule style={{ fontSize: 26 }} />
                            ) : (
                              <ViewList style={{ fontSize: 26 }} />
                            )}
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>

                <LinearProgress
                  style={{
                    borderRadius: 50,
                    opacity: areProgramsLoaded ? 0 : 1,
                  }}
                />
              </Grid>
            </Grid>

            <Grid item container spacing={3}>
              {programs.length > 0 ? (
                listMode ? (
                  programs?.filter(
                    (k) =>
                      filterName === "" ||
                      k?.name.toUpperCase().includes(filterName.toUpperCase())
                  ).length > 0 ? (
                    programs
                      ?.filter(
                        (k) =>
                          filterName === "" ||
                          k?.name.toUpperCase().includes(filterName.toUpperCase())
                      )
                      .map((p, i) => (
                        <Grid key={i} item md={4} xs={12} sm={6}>
                          <ProgramsCard
                            imageUrl={
                              window.location.origin +
                              "/app/programs/" +
                              p.programId +
                              "/image"
                            }
                            title={p.name}
                            description={p.def}
                            id={p.programId}
                            edit={() => {
                              if (canUpdateProgram) {
                                handleEdit(p.programId);
                              }
                            }}
                            remove={() => {
                              if (canDeleteProgram && canDelete(p.programId, authUser.programas)) {
                                handleDelete(p.programId);
                              }
                            }}
                            canEdit={canUpdateProgram}
                            canDelete={canDeleteProgram && canDelete(p.programId, authUser.programas)}
                            groups={authUser.programas}
                          />
                        </Grid>
                      ))
                  ) : (
                    <Grid container alignItems="center" direction="column">
                      <Typography
                        variant="h4"
                        color="textSecondary"
                        style={{ marginTop: 64, justifySelf: "center" }}
                      >
                        {t("programs.notFound")}
                      </Typography>
                    </Grid>
                  )
                ) : (
                  <ProgramsTable
                    authUser={authUser}
                    canDelete={canDelete}
                    canDeleteProgram={canDeleteProgram}
                    canUpdateProgram={canUpdateProgram}
                    filterName={filterName}
                    handleDelete={handleDelete}
                    history={history}
                    programs={programs}
                    handleEdit={handleEdit}
                    t={t}
                  />
                )
              ) : areProgramsLoaded ? (
                <Grid container alignItems="center" direction="column">
                  <Typography variant="h4" style={{ marginTop: 64 }}>
                    {t("No se han podido cargar los programas")}
                  </Typography>

                  <Button
                    variant="outlined"
                    style={{ marginTop: 32 }}
                    color="primary"
                    onClick={loadData}
                  >
                    {t("volver a cargar")}
                  </Button>
                </Grid>
              ) : (
                [0, 1, 2, 3, 4, 5].map((i) => (
                  <Grid key={i} item md={4} xs={12} sm={6}>
                    <LoadingProgramCard />
                  </Grid>
                ))
              )}
            </Grid>

            <ErrorDialog errorMsg={errorMsg} clearError={() => setErrorMsg("")} />

            <ProgramDialog
              isOpen={openProgramModal}
              setIsOpen={setOpenProgramModal}
              edit={editProgram}
              editingData={editinId}
            />

            <DeleteDialog
              isOpen={opendeleteModal}
              close={setOpendeleteModal}
              data={editinId}
            />
          </Container>
        ) : (
          <Redirect to={ROUTES.GROUPS} />
        );
      }}
    </AuthUserContext.Consumer>
  );
};

const ProgramsTable = ({
  programs,
  filterName,
  history,
  authUser,
  handleEdit,
  canDelete,
  canDeleteProgram,
  canUpdateProgram,
  handleDelete,
  t,
}) => (
  <TableContainer component={Paper} style={{ margin: 6 }}>
    <Table aria-label="simple table" size="small">
      <TableHead style={{ backgroundColor: "#023f88" }}>
        <TableRow>
          <TableCell style={{ color: grey[100], fontSize: 18 }}>{t("common.name")}</TableCell>
          <TableCell style={{ color: grey[100], fontSize: 18 }}>{t("common.description")}</TableCell>
          <TableCell style={{ color: grey[100], fontSize: 18 }} align="right">
            {t("common.actions")}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {programs
          ?.filter((k) => filterName === "" || k?.name.toUpperCase().includes(filterName.toUpperCase()))
          .map((p, i) => (
            <TableRow key={i}>
              <TableCell>{p.name}</TableCell>
              <TableCell>{p.def}</TableCell>
              <TableCell align="right" style={{ display: "flex", marginBottom: -1 }}>
                <IconButton
                  aria-label="view"
                  size="small"
                  onClick={() => history.push(ROUTES.PROGRAMS + "/" + p.programId + ROUTES.GROUPS)}
                >
                  <Visibility color="primary" />
                </IconButton>

                <Tooltip
                  title={
                    <Typography variant="body2">
                      {!canUpdateProgram ? t("permissions.noPermission") : t("Modificar programa")}
                    </Typography>
                  }
                >
                  <div>
                    <IconButton
                      aria-label="edit"
                      size="small"
                      disabled={!canUpdateProgram}
                      onClick={() => handleEdit(p.programId)}
                      style={{ marginRight: 6, marginLeft: 6 }}
                    >
                      <Edit color={canUpdateProgram ? "primary" : "disabled"} />
                    </IconButton>
                  </div>
                </Tooltip>

                <Tooltip
                  title={
                    <Typography variant="body2">
                      {!canDeleteProgram
                        ? t("permissions.noPermission")
                        : canDelete(p.programId, authUser.programas)
                          ? t("Eliminar programa")
                          : t("Elimina los grupos para poder eliminar el programa")}
                    </Typography>
                  }
                >
                  <div>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={() => handleDelete(p.programId)}
                      disabled={!canDeleteProgram || !canDelete(p.programId, authUser.programas)}
                    >
                      <Delete
                        color={
                          canDeleteProgram && canDelete(p.programId, authUser.programas)
                            ? "error"
                            : "disabled"
                        }
                      />
                    </IconButton>
                  </div>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  </TableContainer>
);

const condition = (authUser) => !!authUser; //(authUser) => !!authUser;

export default withAuthorization(condition)(ProgramsPage);
